import { useCallback, useEffect, useState } from 'react';
import { YouTubeVideo } from '../types/youtubeFeed';
import { fetchYouTubeFeed } from '../services/youtubeFeedService';

interface UseYouTubeFeedReturn {
    videos: YouTubeVideo[];
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<void>;
}

/**
 * Loads the latest YouTube videos for the public landing page.
 * The service fails closed (returns an empty list) so the section can be
 * hidden entirely when the API is unavailable or returns no videos.
 */
export function useYouTubeFeed(): UseYouTubeFeedReturn {
    const [videos, setVideos] = useState<YouTubeVideo[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            const data = await fetchYouTubeFeed();
            setVideos(data);
            setError(null);
        } catch (err) {
            setError(err as Error);
            setVideos([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { videos, loading, error, refetch: load };
}
